import { computed, inject, Injectable, signal } from '@angular/core';
import { DiceService } from './dice-service.service';

@Injectable({
  providedIn: 'root',
})
export class ExpressionService {
  private readonly $diceService = inject(DiceService);

  public readonly tutorExpression = signal<string | undefined>(undefined);
  public readonly clientExpression = signal<string | undefined>(undefined);
  public readonly isTutorExpressionAvailable = signal(false);
  public readonly isClientExpressionAvailable = signal(false);
  public readonly isRolling = signal(false);
  public readonly isEnabled = computed(
    () => this.isRolling() || this.tutorExpression() !== undefined || this.clientExpression() !== undefined,
  );

  public async choseExpression(faces: string[], whomst: 'TUTOR' | 'CLIENT', result?: number): Promise<void> {
    this.isRolling.set(true);
    const res = await this.$diceService.roll(whomst === 'TUTOR' ? 'PINK' : 'BLUE', faces, result);

    if (whomst === 'TUTOR') {
      this.tutorExpression.set(faces[res]);
    } else {
      this.clientExpression.set(faces[res]);
    }

    this.isRolling.set(false);
  }

  public clearExpression(whomst: 'TUTOR' | 'CLIENT'): void {
    if (whomst === 'TUTOR') {
      this.tutorExpression.set(undefined);
    } else {
      this.clientExpression.set(undefined);
    }
  }

  public setAvailability(whomst: 'TUTOR' | 'CLIENT', isAvailable: boolean): void {
    if (whomst === 'TUTOR') {
      this.isTutorExpressionAvailable.set(isAvailable);
      if (!isAvailable) {
        this.clearExpression('TUTOR');
      }
    } else {
      this.isClientExpressionAvailable.set(isAvailable);
      if (!isAvailable) {
        this.clearExpression('CLIENT');
      }
    }
  }
}
